import script from "./PrefecturesSelects.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrefecturesSelects.vue?vue&type=script&setup=true&lang=ts"

import "./PrefecturesSelects.vue?vue&type=style&index=0&id=51909112&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51909112"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect});
